import { useEffect, Suspense } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import isPast from 'date-fns/isPast'

import { Routes, Route, useLocation } from 'react-router-dom'
import { Box } from '@mui/system'
import { ApplicationState } from '@/state/root.models'

import logoutThunk from '@/state/auth/thunk/logout.thunks'
import { uiGlobalSelector } from '@/state/ui/global/slices/index.slices'
import SidebarComponent from '@/views/layouts/sidebar/index.component'

import TopBarComponent from '@/views/layouts/top-bar/top-bar.component'
import ErrorPage from '@/views/pages/error/index.page'
import { ADMIN_VIEW } from '@/constants/brand'

import { sidebarOpenWidth, sidebarClosedWidth } from '@/constants/sidebar'
import { useAppDispatch } from '@/state'
import appRoutes from './app-routes.component'

import GlobalPageLoader from '../global-page-loader/index.component'

const AuthorizedApp = () => {
  const { pathname } = useLocation()

  const dispatch = useAppDispatch()

  const { userSession, token, unauthorized, brand, loggedUser } = useSelector(
    ({ auth }: ApplicationState) => auth,
    shallowEqual,
  )

  /**
   * Checks if the token expiration time is not longer valid
   * WT token expires in an 1hr
   */
  const hasTokenExpired = () => isPast(new Date(userSession?.exp * 1000))

  useEffect(() => {
    if (userSession?.exp) {
      if (!unauthorized) {
        dispatch(logoutThunk())
      }

      if (hasTokenExpired() || !token) {
        dispatch(logoutThunk())
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, pathname, unauthorized, dispatch])

  const { sidebarStatus } = useSelector(uiGlobalSelector)

  return (
    <Box display="flex">
      <SidebarComponent />
      <Box
        display="block"
        width={`calc(100% - ${
          sidebarStatus ? sidebarOpenWidth : sidebarClosedWidth
        }px)`}
      >
        <TopBarComponent />
        <Suspense fallback={<GlobalPageLoader open />}>
          <Routes>
            {appRoutes.routes
              .filter(
                (route) =>
                  (brand.siteId === ADMIN_VIEW && route.hideSiteId === '') ||
                  brand.siteId !== ADMIN_VIEW,
              )
              .map((item) => {
                const roles = item.roles ? item.roles : ''
                if (userSession?.role !== undefined && loggedUser !== null) {
                  if (roles.includes(`${userSession?.role.toString()}`)) {
                    return (
                      <Route
                        path={item.path}
                        element={item.render}
                        key={item.path}
                      />
                    )
                    // eslint-disable-next-line
                  } else {
                    return (
                      <Route
                        path={item.path}
                        key={item.path}
                        element={<ErrorPage />}
                      />
                    )
                  }
                  // eslint-disable-next-line
                } else {
                  return (
                    <Route
                      path={item.path}
                      key={item.path}
                      element={<ErrorPage />}
                    />
                  )
                }
              })}
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Suspense>
      </Box>
    </Box>
  )
}

export default AuthorizedApp
